import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useAppStore } from 'Store/App'
import { useProjectStore } from 'Store/Project'
import { shallow } from 'zustand/shallow'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { extractScannedCode, extractItemId } from 'Utils/extractScannedCode'
import { inferScanTypeFromCode } from 'Utils/scanInventoryType'

const ViewModel = () => {
  const { id: projectId } = useParams()
  const setShowBackButton = useAppStore(state => state.setShowBackButton, shallow)
  const scanReceive = useProjectStore(state => state.scanReceivePile, shallow)
  const scanReceiveFromShippingRequestId = useProjectStore(
    state => state.scanReceivePileFromShippingRequestId,
    shallow
  )
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [scanCode, setScanCode] = useState('')
  const [isUseCamera, setIsUseCamera] = useState(false)
  const [hasCamera, setHasCamera] = useState(false)

  const isDev = process.env.NODE_ENV === 'development'

  const onChangeInput = (e: any) => {
    setScanCode(e.target.value)
  }

  const handleSubmitScanCode = (code: string, rawScan?: string) => {
    setIsSubmitting(true)

    if (code.length === 0) {
      toast.error('กรุณาระบุรหัสเสา')
      setIsSubmitting(false)
    } else {
      scanReceive(parseInt(projectId ?? ''), {
        inventoryCode: code,
        type: inferScanTypeFromCode(rawScan ?? code),
        itemId: extractItemId(rawScan ?? code),
      }).then(({ success, data }) => {
        if (success) {
          setScanCode('')
          toast.success('สแกนสำเร็จ')
        } else {
          toast.error(data)
        }

        setIsSubmitting(false)
      })
    }
  }

  const handleScan = (scanData: any) => {
    if (scanData) {
      const rawValue = scanData[0].rawValue.trim()
      const code = extractScannedCode(scanData)
      Swal.fire({
        title: 'ยืนยันการสแกน?',
        text: `คุณสแกนรหัส: ${code}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
      }).then((result: any) => {
        // alert(result.isConfirmed);
        if (result.isConfirmed) {
          handleSubmitScanCode(code, rawValue)
        }
      })
    }
  }

  const toggleUseCamera = () => {
    const nextValue = !isUseCamera
    if (!hasCamera) {
      toast.error('ไม่พบกล้อง')
      return
    }
    setIsUseCamera(nextValue)
  }

  const onHandleScanReceiveAll = () => {
    if (!isDev) return

    setIsSubmitting(true)

    withReactContent(Swal)
      .fire({
        input: 'number',
        inputLabel: 'Shipping Request ID',
        inputPlaceholder: 'Enter shipping request ID',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          const shippingRequestId = parseInt(result.value)
          scanReceiveFromShippingRequestId(parseInt(projectId ?? ''), shippingRequestId).then(
            ({ success, data }) => {
              if (success) {
                toast.success('สแกนทั้งหมดสำเร็จ')
              } else {
                toast.error(data)
              }

              setIsSubmitting(false)
            }
          )
        } else {
          setIsSubmitting(false)
        }
      })
  }

  useEffect(() => {
    setShowBackButton(true)

    return () => {
      setShowBackButton(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId])

  useEffect(() => {
    async function checkCameraAvailability () {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices()
        setHasCamera(devices.some(device => device.kind === 'videoinput'))
      } catch (error) {
        console.error('Error checking camera availability:', error)
      }
    }

    checkCameraAvailability()
  }, [])

  return {
    isDev,
    projectId,
    isSubmitting,
    isUseCamera,
    onChangeInput,
    scanCode,
    handleScan,
    hasCamera,
    setScanCode,
    toggleUseCamera,
    onHandleScanReceiveAll,
  }
}

export default ViewModel
